var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"relative right-0 w-56 rounded-md shadow-lg z-50",attrs:{"id":"autocompletePopup"}},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }